import React, { useEffect, useState } from 'react';
const LINKS = [{
  href: '#lite-vin',
  label: 'Lite Vin'
}, {
  href: '#skalan',
  label: 'Skalan'
}, {
  href: '#vinbrickor',
  label: 'Vinbrickor'
}, {
  href: '#vin-pa-glas',
  label: 'Vin på glas'
}];
export function WineNav() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const section = document.getElementById('lite-vin');
    if (!section) return;
    const onScroll = () => {
      const top = section.getBoundingClientRect().top;
      setVisible(top <= 80);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <nav aria-label="Lite Vin" className={`sticky top-16 md:top-20 z-40 w-full bg-cream/95 backdrop-blur border-b border-ink/10 transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-279" data-mp="siaf587v79pd">
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between gap-4" data-id="element-280" data-mp="1l4d04j7yrr7a">
        <ul className="flex items-center gap-5 sm:gap-7 overflow-x-auto" data-id="element-281" data-mp="eljoildlasx">
          {LINKS.map(link => <li key={link.href} data-id="element-282" data-mp="5f0up3i6q67q">
              <a href={link.href} className="block whitespace-nowrap font-sans text-[10px] tracking-[0.2em] uppercase text-ink/55 hover:text-ink transition-colors duration-200" data-id="element-283" data-mp="3nrfjccju18wu">
                {link.label}
              </a>
            </li>)}
        </ul>
        <a href="#boka-bord" className="shrink-0 inline-flex items-center px-5 py-2.5 rounded-full bg-ink text-white font-sans text-[10px] tracking-[0.2em] uppercase hover:bg-ink/85 transition-colors duration-200" data-id="element-284" data-mp="3is2x9u0sc5vb">
          Boka bord
        </a>
      </div>
    </nav>;
}